export default __webpack_public_path__ + "static/media/Logo_CSS.409b3a09.png";